// Import SASS
import '../sass/style.scss'

// Import scripts
import objectFitImages from 'object-fit-images'
import Rellax from 'rellax'
import sal from 'sal.js'
//import './modules/pageTransitions'
import mobileNav from './modules/navigation'
import './modules/stickyvideo'
import './modules/skip-link-focus-fix'
//import './modules/two.min.js'
//import './modules/wheel'
import { caseSlider, teamSlider, clientsSlider } from './modules/sliders'
import { detectMobile } from './modules/helpers'
import search from './modules/search'
//import instagram from './modules/instagram'
//import modal from './modules/modal'
import modals from './modules/modals.js';
// import map from './modules/map'
//import maps from './modules/maps'

const startScripts = () => {
	// progress bars
	//pace.start()

	// Object-fit fix
	objectFitImages()

	caseSlider('.cases-slider')
	teamSlider('.team-slider')
	clientsSlider('.clients-slider')

	search('.search-field')

	//instagram('#insta')

  if (document.querySelector(".main-navigation")) { 

	 mobileNav();

  }

	// setTimeout(() => { modal('[data-modal]') }, 1000)

	// Relax slow scroll effect
	const introCard = document.querySelector('.intro .card')
	if (introCard && !detectMobile()) {
		const rellax = new Rellax('.intro .card, .news-grid > div:nth-child(1)', {
			speed: -1.5,
			center: true,
			round: true
		})
	}

	// animations when in viewport
	sal()

	var faqToggle = document.querySelectorAll(".faq__question");
for (var i = 0; i < faqToggle.length; i++) {
    faqToggle[i].onclick = function () {
        this.nextElementSibling.classList.toggle("active");
        this.querySelector('.arrow').classList.toggle('active');
    };
}


}
startScripts()

modals.init( {
  backspaceClose: false,
  callbackOpen: function ( toggle, modal ) {

    var modalbut = document.querySelector(".modal__button");


    modalbut.classList.remove("fadeInUp");
    modalbut.classList.remove("animated");
    modalbut.classList.remove("active");

  },
  callbackClose: function ( toggle, modal ) {

    var modalbut = document.querySelector(".modal__button");

    modalbut.classList.add("fadeInUp");
    modalbut.classList.add("animated");
    modalbut.classList.add("active");

  }


} );


if (document.querySelector(".modal")) { 

  var modal = document.querySelector(".modal");
  var modalbut = document.querySelector(".modal__button");

  // When the window is loaded....
  window.addEventListener("load", function() {

    if(document.cookie.indexOf("visited") >= 0) {

       modalbut.classList.add("fadeInUp");
        modalbut.classList.add("animated");
        modalbut.classList.add("active");
      
      
    } else {

        setTimeout(function(){

          modal.classList.add("fadeInUp");
          modal.classList.add("animated");
          modal.classList.add("active");

          modals.openModal( null, '#popup' );
          
        }, 1000);
       

    }



  });

}


//Barba.Dispatcher.on('transitionCompleted', function (currentStatus, oldStatus, container) {
//	startScripts()
//})

